
<template>
  <div>
    <div class="margin-bottom-10" v-if="type=='query'">
        <Button v-if="formData.reserveOrderStatus == 10 || formData.reserveOrderStatus == 15" type="warning" @click="freeReserve">释放预留</Button>
        <Button v-if="formData.reserveOrderStatus == 0" @click="clickBtn('sure')" class="margin-left-10" type="primary">确认</Button>
        <Button v-if="formData.reserveOrderStatus == 0" @click="clickBtn('cancel')" class="margin-left-10">取消</Button>
    </div>
    <compWrapper title="基本信息" theme="primary">
        <compFormQuery v-if="type=='query'" :formdata="getBase" :value="formData"></compFormQuery>
        <compFormEdit v-else ref="editform" class="margin-layout" :formdata="getBase" v-model="formData" />
    </compWrapper>
    <compWrapper title="产品信息" theme="primary">
        <div v-if="type != 'query'" class="margin-top-15" style="display: flex">
            <Form ref="productForm"
                :labelWidth="80"
                :model="skuData"
                inline>
                <FormItem label="SKU" style="margin-bottom: 15px;position:relative" >
                    <Icon type="ios-medical" style="position:absolute;top:10px;left:-50px;color:red" />
                    <Input v-model="skuData.sku" readonly>
                        <Icon style="cursor: pointer" type="ios-search" slot="suffix" @click="handleSKU"></Icon>
                    </Input>
                </FormItem>
                <FormItem class="margin-left-20" label="可用库存" style="margin-bottom: 15px">
                    <div class="width-100per" >{{skuData.inventoryAvailable}}</div>
                </FormItem>
                <FormItem class="margin-left-20" label="数量" style="margin-bottom: 15px;position:relative" >
                    <Icon type="ios-medical" style="position:absolute;top:10px;left:-50px;color:red"/>
                    <InputNumber class="width-100per" v-model="skuData.qty" :min="1" @on-blur="blurinput(skuData.qty)"></InputNumber>
                </FormItem>
            </Form>
            <div class="margin-left-50">
                <Button class="margin-left-15" type="primary" @click="addOne({qty:skuData.qty,sku:skuData.sku,inventoryAvailable:skuData.inventoryAvailable})">添加</Button>
                <Button class="margin-left-15" type="info" @click="importItem">导入</Button>
            </div>
        </div>
        <div v-if="type != 'query'" class="margin-left-45">
            <Button @click="deleteOne">删除</Button>
            <Button class="margin-left-15" @click="clearAll">清空</Button>
        </div>
        <div style="margin: 15px">
            <Table size="small"
                border
                :columns="columns"
                :data="productList"
                @on-selection-change="handleColumnsSelect"></Table>
        </div>
    </compWrapper>
    <compWrapper title="操作历史" theme="gray" v-if="query">
        <compLog class="margin-15" :data="opLogList" ></compLog>
    </compWrapper>
    <div class="text-right">
        <Button v-if="!query" type="primary" @click="submit('edit')">保存为草稿</Button>
        <Button v-if="!query" type="info" class="margin-left-10" @click="submit('sure')">保存并确认</Button>
        <Button v-if="showalert == 1" class="margin-left-10" @click="close">返回</Button>
        <Button v-else class="margin-left-10" @click="cancel">返回</Button>
    </div>
    <!-- 全局弹框 -->
    <compModal
        v-model="modalProps.show"
        v-bind="modalProps"
        @on-confirm="modalProps={}"
        @on-close="modalProps={}"
    >
        <component ref="cusref" :is="modalProps.component"  v-bind="modalProps" @on-close="modalProps={}" v-on="modalProps.on"></component>
    </compModal>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>
<script>

import { HttpQueryReserveOrder, HttpSaveReserveOrder, HttpSaveSureReserveOrder, HttpSureReserveOne,HttpCancelReserveOne } from '@/service/setting';
import { HttpUserManageWarehouse } from '@/service/bespeak';

import { mapGetters } from "vuex";
import compSku from './sku'
import comRelease from './release'

export default {
    props: ['activeid', 'querytype','showalert'],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
        compSku,
        comRelease,
    },
    data () {
        return {
            loading: false,
            type: this.$route.params.type || this.querytype,
            id: this.$route.query.id || this.activeid,
            opLogList: [],
            formData: {},
            skuData:{qty:'',sku:''},
            oldendTime: '',
            productList: [],
            modalProps:{},
            required: [{
                required: true,
                message: this.$t('global.form.required', { defaultValue: "该信息不能为空,请填写" })
            }],
            checkedData:[],
        }
    },
    created () {
        this.query = this.type === "query";
        if (this.type == 'edit' || this.type == 'query') {
            this.getDetail()
        }
    },
    computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusBillTypeList', 'getUserManageWarehouseList','getSysAllList']),
        getBase () {
            let showquery = this.type == 'query' || this.type == 'edit'
            return [
                {
                    label:'预留单号',
                    key:'reserveNo',
                    show:this.type == 'query'
                },
                {
                    label:'状态',
                    key:'reserveOrderStatus',
                    tag:'Select',
                    options:[
                        {value:'0',label:'草稿'},
                        {value:'5',label:'已取消'},
                        {value:'10',label:'已预留'},
                        {value:'15',label:'部分预留'},
                        {value:'20',label: '已释放'},
                        {value:'25',label:'已释放'}
                    ],
                    show:this.type == 'query'
                },
                {
                    label: "客户",
                    key: "organizationId",
                    tag: "vSelect",
                    options: this.type=='query'? this.getSysAllList:this.getSelfmanageorgList,
                    query:this.type == 'query',
                    valueText: this.formData.orgName,
                    props: {
                        filterable: true,
                    },
                },
                {
                label: "仓库",
                    key: 'orgWarehouseCode',
                    tag: 'vSelect',
                    options: this.getUserManageWarehouseList,
                    props: {
                        filterable: true,
                    },
                    query:this.type == 'query',
                    valueText: this.formData.orgWarehouseName
                    
                },
                {
                    label: "库存类型",
                    key: 'inventoryType',
                    tag: 'vSelect',
                    options: [
                        { value: 0, label: '可售库存' },
                        { value: 1, label: '不可售库存' },
                    ],
                },
                {
                    label: "来源单号",
                    key: "sourceNo",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: "备注",
                    key: "remark",
                    tag: "vInput",
                    required: false,
                },

            ];
        },
        columns () {
            let data = [
                {
                    type: "selection",
                    align: "center",
                    width:200,
                },
                {
                    type: "index",
                    title: "序号",
                    align: "center",
                    width:200,
                },
                {
                    title: "SKU",
                    key: "sku",
                    align: "center",
                },
                // {
                //     title: "可用库存",
                //     key: "inventoryAvailable",
                // },
                {
                    title: "预留数量",
                    key: "qty",
                    align: "center",
                },
                {
                    title: "释放数量",
                    key: "qtyDone",
                    align: "center",
                }
            ]
            if(this.type == 'query'){
                data.splice(0,1)
                return data
            }
            if(this.type != 'query'){
                data.splice(4,1)
                return data
            }
            return data
        }
    },
    methods: {
        blurinput(val){
            console.log(val)
            this.skuData.qty = Math.round(val)
            console.log(this.skuData.qty)
        },
        freeReserve(){
            this.modalProps = {
                show: true,
                alert: "info",
                title: "释放预留",
                width: 560,
                component: "comRelease",
                itemList: this.formData.reserveOrderItemList,
                id: this.id,
                showFooter: false,
                on:{
                    'on-update':()=>{
                        this.$emit('on-update')
                    }
                }
            };
        },
        clickBtn(type){
            switch(type){
                case 'sure':
                    this.modalProps = {
                        show: true,
                        alert: "primary",
                        params: { id: this.id },
                        title: "确认操作",
                        ajaxRequest: HttpSureReserveOne,
                        callback: (res) => {
                            this.$VMessage.success(res.message);
                            this.getDetail()
                            this.$emit('on-update')
                        },
                    }
                break;

                case 'cancel':
                    this.modalProps = {
                        show: true,
                        alert: "warning",
                        params: { id: this.id },
                        title: "取消操作",
                        formdata:[
                            {
                                label: "备注",
                                key: 'remark',
                                tag: 'vTextarea',
                                span: 24,
                                labelWidth: 60,
                                required:false,
                            },
                        ],
                        ajaxRequest: HttpCancelReserveOne,
                        callback: (res) => {
                            this.$VMessage.success(res.message);
                            this.getDetail()
                            this.$emit('on-update')
                        },
                    }
                break;
            }
        },
        async getDetail () {
            this.loading = true;
            HttpQueryReserveOrder({
                id: this.id
            }).then(res => {
                this.formData = res.data
                this.productList = res.data.reserveOrderItemList;
                this.opLogList = res.data.orderLogs;
                this.loading = false;
            }, err => {
                this.loading = false;
                this.$VMessage.error(err.message);
            });
        },
        async handleSKU () {
            const valid = await this.$refs.editform.validate()
            if (!valid) return;
            let WareCode = this.getUserManageWarehouseList.filter(item=>{
                return item.attach.code == this.formData.orgWarehouseCode
            })
            this.modalProps = {
				show: true,
				title: 'SKU',
				component: "compSku",
				showFooter: false,
				width: 1000,
				initFormData: {
                    "search[EQ_inventoryType]": this.formData.inventoryType,
                    "search[EQ_orgWarehouseId]": WareCode[0].attach.id,
                    "search[EQ_orgWarehouseCode]": this.formData.orgWarehouseCode,
                    "search[EQ_organizationId]":this.formData.organizationId
                },
				on: {
					'on-data': (row) => {
                        // console.log(row)
						const { sku = "", inventoryAvailable = "", } = row;
                        this.skuData.inventoryAvailable = row.inventoryAvailable;
                        this.skuData.sku = row.sku;
						this.modalProps.show = false;
					}
				},
			}
        },
        addOne (data) {
            const { sku, qty, inventoryAvailable } = data;
            if (sku && qty) {
                const erpSkuData = this.productList.find((item) => {
                    return item.sku === sku
                });
                if (erpSkuData) {
                    erpSkuData.qty += qty;
                } else {
                    this.productList.push(data)
                }
                this.skuData = { qty: '', sku: '',inventoryAvailable:'' };

                return;
            }
            this.$VMessage.warning('请填写ERPSKU和预留数量');
        },
        async importItem () {
            const valid = await this.$refs.editform.validate()
            if (!valid) return;
            let WareCode = this.getUserManageWarehouseList.filter(item=>{
                return item.attach.code == this.formData.orgWarehouseCode
            })
            this.modalProps = {
                show: true,
                title: this.$t('fbb.alloment.import_data', { defaultValue: '导入数据' }),
                width: 460,
                showFooter: false,
                action: process.env.VUE_APP_APIURL_FBB + "/api/v2/ReserveOrder/importItem",
                name: "multipartFile",
                component: "compUpload",
                download: () => {
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/ReserveOrder/itemTemplate", {}, 'download')
                },
                data: {
                    id:this.id?this.id:'',
                    orgWarehouseId:WareCode[0].attach.id,
                    orgWarehouseCode:this.formData.orgWarehouseCode,
                    inventoryType:this.formData.inventoryType,
                    organizationId:this.formData.organizationId,
                },
                on:{
                    'on-success':(row)=>{
                        console.log(row)
                        this.productList = row.data;
                        this.modalProps = {}
                        // Object.values(row.data || []).forEach((item) => {
						// 	this.productList.push(item);
						// })
                    },
                }
            };
        },
        handleColumnsSelect (selection) {
            this.checkedData = selection;
        },
        deleteOne () {
            const checkedData = this.checkedData;
            if (!checkedData.length) {
                this.$VMessage.warning(this.$t('global.common.choose', { defaultValue: '请选择产品' }));
                return
            }
            this.modalProps = {
                show: true,
                title: this.$t('global.common.delete', { defaultValue: '删除' }),
                alert: 'warning',
                ajaxRequest: async () => {
                    this.checkedData.map((deleteItem) => {
                        this.productList.map((item, index) => {
                            if (deleteItem.sku == item.sku) {
                                this.productList.splice(index, 1);
                            }
                        });
                    });
                    return { message: this.$t('global.common.have_deleted', { defaultValue: '已删除' }) };
                }
            }
        },
        clearAll () {
            this.modalProps = {
				show: true,
				title: this.$tc('global.common.clear', 1, { defaultValue: '清空所有' }),
				alert: 'error',
				ajaxRequest: async () => {
					this.productList = [];
					return { message: this.$t('global.common.haveto_empty', { defaultValue: '已清空' }) };
				}
			}
        },
        async submit (type) {
            const valid = await this.$refs.editform.validate()
            if (!valid) return;

            if (!this.productList.length) {
                this.$VMessage.warning("产品信息不能为空！");
                return
            }
            let WareCode = this.getUserManageWarehouseList.filter(item=>{
                return item.attach.code == this.formData.orgWarehouseCode
            })
            this.loading = true;
            if(type == 'edit'){
                
                HttpSaveReserveOrder({
                    ...this.formData,
                    orgWarehouseId:WareCode[0].attach.id,
                    itemList:this.productList,
                }).then(res => {
                    this.loading = false;
                    this.$VMessage.success(res.message);
                    this.cancel();
                }, err => {
                    this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                    });
                    this.loading = false;
                })
            }else{
                HttpSaveSureReserveOrder({
                    ...this.formData,
                    orgWarehouseId:WareCode[0].attach.id,
                    itemList:this.productList,
                }).then(res => {
                    this.loading = false;
                    this.$VMessage.success(res.message);
                    this.cancel();
                }, err => {
                    this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                    });
                    this.loading = false;
                })
            }
        },
        cancel () {
            this.$router.push({ name: "settingReservedList" })
        },
        close(){
            this.$emit('on-close')
        }
    },
}
</script>
